import { AiFillCheckCircle, AiFillCloseCircle, AiFillExclamationCircle } from 'react-icons/ai';
import { MdCelebration } from 'react-icons/md';
import { toast } from 'react-toastify';

const customTypes = {
  success: {
    color: 'text-green-500',
    icon: AiFillCheckCircle,
  },
  error: {
    color: 'text-red-500',
    icon: AiFillCloseCircle,
  },
  info: {
    color: 'text-amber-500',
    icon: AiFillExclamationCircle,
  },
  spec: {
    color: 'text-dark-500',
    icon: MdCelebration,
  },
};

function notification({ type = 'info', title, description }) {
  const Icon = customTypes[type].icon;
  const { color } = customTypes[type];

  return toast(
    <div className="flex">
      <div className="w-14">
        <Icon className={`${color} w-7 h-7`} />
      </div>
      <div className="flex-grow">
        {
        type === 'spec' && (
        <div className="w-full text-dark-500">
          <h1 className="font-bold font-sans">Easter Egg!</h1>
          <p className="text-sm text-right font-semibold font-sans text-white">{window.atob('U3VtaXQgTWVocmE=')}</p>
        </div>
        )
      }
        <div className={`font-sans font-medium ${color}`}>
          {title}
        </div>
        <div className="text-sm font-sans">{description}</div>
      </div>
    </div>,
  );
}

export default notification;
